import api from '@/apis/di/fixedAssetAPI.js';
import CrudCache from '@/stores/crudBaseCache.js';
var crud = new CrudCache('fixedAssetCache', api);
import commonFn from '@/commons/commonFunction';
import IndexedDB from '@/commons/indexedDB';

const state = {
  ...crud.state,
  _config: {
    table: 'di_fixed_asset',
    field: {
      key: 'fixed_asset_id',
      code: 'fixed_asset_code',
      name: 'fixed_asset_name',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  updateItemCombo(context, res) {
    //cập nhật danh sách
    context.commit('updateItem', res);
  },
  insertItemCombo(context, res) {
    //cập nhật danh sách
    context.commit('insertItem', res);
    context.commit('sortByCode');
  },
  deleteItemCombo(context, deleted) {
    //Commit thực hiện xóasinp
    context.commit('deleteItems', deleted);
  },
  updateItemQuickFllowCombo(context, res) {
    //Commit thực hiện xóasinp
    context.commit('updateItemQuickFllow', res);
  },
  async loadDataFixedAsset(context, res) {
    //Lấy ra module cache hiện tại theo table
    let currentModule = 'fixedAssetCache';
    let _indexDB = new IndexedDB();
    //Lấy ra tất cả key cache
    let keyCaches = await _indexDB.getKeys();
    //Lấy ra các key lưu dữ liệu cache của riêng màn này
    let myKeys = keyCaches?.filter(key => key.startsWith(`ms_mimosa_cacheDi_${currentModule}`));
    //Xóa cache
    if (myKeys && myKeys.length > 0) {
      myKeys.forEach(key => {
        _indexDB.delete(key.replace('ms_mimosa_', ''));
      });
      //Load lại cache
      await context.dispatch('loadFullCache', {isReload: true});
    }

    commonFn.unmask();
  },
  /**
   * update loading
   * @param {*} context
   * @param {*} res
   */
  updateLoading(context, res) {
    context.commit('updateLoading', res);
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
